import React from "react";
import Button from '@mui/material/Button';
import { ValidateVehicleInput } from "./../ValidateVehicleInput";

const btnsArray = [
  { buttonOperation: "Display" },
  { buttonOperation: "Change" },
  { buttonOperation: "Create" },
];

export default function OverviewButtons({
  vehicle,
  navigate,
  _getVehicleExists,
  _createErrorMessage,
}) {
  const onClick = (buttonOperation, noValidation, navPath) => {
    //If create button is pressed then just proceed to route
    let navigationUrl;
    if (buttonOperation === "Create") {
      navigationUrl = `/Vehicle/Create`;
      navigate(navigationUrl);
      return;
    }

    let validationVehicleResult = ValidateVehicleInput(
      vehicle,
      _createErrorMessage
    );

    if (!validationVehicleResult) {
      return;
    }

    _getVehicleExists({ data: { Id: vehicle } }, ({ data: isExist }) => {
      if (!isExist) {
        _createErrorMessage("64");
        return;
      }
      const navigationUrl = `/Vehicle/${vehicle}/${buttonOperation}`;
      navigate(navigationUrl);
    });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
      }}
      className="customButton"
    >
      {btnsArray.map(({ buttonOperation, noValidation, navPath }, i) => (
        <div style={{ width: "48%", marginBottom: 15 }} key={i}>
          <Button
            className="btn btn-primary w-100"
            onClick={() => onClick(buttonOperation, noValidation, navPath)}
          >
            {buttonOperation}
          </Button>
        </div>
      ))}
    </div>
  );
}
